import { defaultLanguage } from 'cf-i18n/constants'
import { useLangCookie } from 'cf-i18n/cookies'
import { AnimatePresence, motion } from 'framer-motion'
import { Button } from '../../components/button'
import { Confetti } from '../../components/confetti'
import * as Dialog from 'primitives/dialog'

import i18n from '../../i18n/complete-screens-i18n.json'

interface CoinSuccessDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function CoinSuccessDialog({ open, onOpenChange }: CoinSuccessDialogProps) {
  const [langCookie] = useLangCookie()
  const locale = langCookie || defaultLanguage
  const t = i18n[locale as keyof typeof i18n] ?? i18n.en

  const initial = { y: 12, opacity: 0 }
  const animate = { y: 0, opacity: 1 }

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal forceMount>
        <Dialog.Body>
          <div className="relative h-full max-h-[623px] w-full max-w-[1007px] p-4 text-gray-900 bg-[#fff] rounded-4">
            <div className="relative flex h-full w-full flex-col items-center justify-center rounded-2xl bg-white p-4">
              <Confetti />
              <AnimatePresence>
                <motion.h4
                  key="h4"
                  initial={initial}
                  animate={animate}
                  transition={{ delay: 0.32 }}
                  className="text-[18px] font-[700] leading-[23.10px] text-[#6B7280] lg:text-[24px] text-center"
                >
                  {t.coin_pack_welcome}
                </motion.h4>
                <motion.h2
                  key="h2"
                  initial={initial}
                  animate={animate}
                  transition={{ delay: 0.41 }}
                  className="payments-animated-header text-[48px] font-[700] text-[#2A1F3F] lg:text-[72px] text-center"
                >
                  {t.coin_pack}
                </motion.h2>
                <motion.div
                  key="div"
                  initial={initial}
                  animate={animate}
                  transition={{ delay: 0.5 }}
                  className="flex w-full justify-center"
                >
                  <Button
                    type="button"
                    onClick={() => onOpenChange(false)}
                    className="mt-[20px] w-full grow sm:max-w-[376px]"
                  >
                    {t.get_started}
                  </Button>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </Dialog.Body>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
